document.addEventListener('DOMContentLoaded', function () {

    const form = document.getElementById('complaintform');
    const contactForm = document.getElementById('general-question-form');
    const productQuestionForm = document.getElementById('product-question-form');
    const ingredientQuestionForm = document.getElementById('ingredient-question-form');

    const submitButton = document.getElementById('complaintform_submit');
    
    const privacyCheckbox = document.getElementById('complaintform_checkbox');
    
    const noDate = document.getElementById('no-mhd');
    const noTime = document.getElementById('no-time');

    const noDateHint = document.getElementById('production-time-hint');
    const timeFormRow = document.getElementById('production-time-row');

    const lotNumberWrapper = document.getElementById('lot-number-wrapper');
    const lotNumber = document.getElementById('form-lotNumber');
    const lotNumberField = document.getElementById('complaintform_lotNumber');
    const noLotNumber = document.getElementById('no-lot-number');

    const productFamilySelect = document.getElementById('complaintform_productFamily');
    const bestBeforeDate = document.getElementById('complaintform_bestBeforeDate');
    const bestBeforeTime = document.getElementById('complaintform_productionTime');
    const productSelect = document.getElementById('complaintform_product');
    const productType = document.getElementById('complaintform_productType');

    const formSteps = document.getElementsByClassName('form-step');
    const progressBar = document.getElementsByClassName('progress-step');

    let formState = {
        currentStep: 0,
        termsAccepted: false,
        isValid: false,
        formFields: [],
        validSteps: {}
    };

    const createOption = (text, selectedValue) => {
        let option = document.createElement('option');
        option.text = text;
        // set selected value accordingly
        option.selected = text === selectedValue;
        return option;
    };

    const initializeProductFamilyDropdown = () => {
        const selectedProductFamily = productFamilySelect.value;
        lotNumber.style.display = 'none';
        lotNumberWrapper.style.display = 'none';

        let placeholderFamily = productFamilySelect.options[0];
        $(productFamilySelect).empty();
        productFamilySelect.add(placeholderFamily);

        if (selectedProductFamily && products[selectedProductFamily].hasLotNumber === true) {
            lotNumber.style.display = 'block';
            lotNumberWrapper.style.display = 'flex';
            lotNumberField.required = true;
        } else {
            lotNumber.style.display = 'none';
            lotNumberWrapper.style.display = 'none';
            lotNumberField.value = '';
            lotNumberField.required = false;
        }

        // Add options
        for (productFamily in products) {
            productFamilySelect.add(createOption(productFamily, selectedProductFamily));
        };
    };

    const changeProductFamily = () => {
        const selectedProductFamily = productFamilySelect.value;
        const selectedProductType = productType.value;
        lotNumber.style.display = 'none';
        lotNumberWrapper.style.display = 'none';

        // save placeholder element
        let placeholderSelect = productSelect.options[0];
        let placeholderType = productType.options[0];
        
        // empty productType selections
        $(productSelect).empty();
        $(productType).empty();

        // productFamilySelect.add(placeholderFamily);
        productSelect.add(placeholderSelect);
        productType.add(placeholderType);
     
        // add matching options for selected product
        if (selectedProductFamily && products[selectedProductFamily]['products']) {
            if (products[selectedProductFamily].hasLotNumber === true) {
                lotNumber.style.display = 'block';
                lotNumberWrapper.style.display = 'flex';
                lotNumberField.required = true;
            } 
            for(productItem in products[selectedProductFamily]['products']) {
                productSelect.add(createOption(productItem, selectedProductType));
            }
        } else {
            lotNumber.style.display = 'none';
            lotNumberWrapper.style.display = 'none';
            lotNumberField.value = '';
            lotNumberField.required = false;
        }
    };

    const changeProduct = () => {
        const selectedProductFamily = productFamilySelect.value;
        const selectedProduct = productSelect.value;
        const selectedProductType = productType.value;

        if (!selectedProductFamily) {
            return;
        }

        if (!selectedProduct) {
            return;
        }

        // save placeholder element
        let placeholderType = productType.options[0];
        
        // empty productType selections
        $(productType).empty();

        productType.add(placeholderType);
     
        // add matching options for selected product
        if (products[selectedProductFamily]['products'][selectedProduct]) {
            products[selectedProductFamily]['products'][selectedProduct].forEach(function (type) {
                productType.add(createOption(type, selectedProductType));
            });
        }
    };

    const addEventListeners = (stepIndex) => {
        // Add event listeners to form fields
        const currentFields = formSteps[stepIndex].querySelectorAll('input, select, textarea, checkbox');
        
        currentFields.forEach(field => {
            
            // add event listener to each field to validate on change
            field.addEventListener('input', function () {
                if (validateStep(stepIndex)) {
                    if (stepIndex < formSteps.length - 1) {
                        showStep(stepIndex + 1);
                    } 
                } 
            });
        });
    };

    const validateStep = (stepIndex) => {
        const currentFields = formSteps[stepIndex].querySelectorAll('input, select, textarea, checkbox');

        let isValid = true;

        currentFields.forEach(field => {
            const fieldType = field.type;
            let hasValue = false;

            const validationRules = {
                'address,zip': /^[0-9]{5}$/,
                'email': /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
                'time': /^[0-9]{2}:[0-9]{2}$/,
                'date': /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/,
            };

            if (fieldType === 'checkbox' || fieldType === 'radio') {
                hasValue = field.checked;
            } else {
                const validationRule = validationRules[field.dataset.formType] ? validationRules[field.dataset.formType] : validationRules[fieldType];

                if (validationRule) {
                    hasValue = field.value.trim().match(validationRule) !== null;
                } else {
                    hasValue = field.value.trim().length > 0;
                }
            }

            if (field.required && hasValue) {
                field.parentElement.classList.remove('form-error');
            } else if (field.required && !hasValue) {
                field.parentElement.classList.add('form-error');
                isValid = false;
                return isValid; 
            }  
            
            if (!field.required) {
                field.parentElement.classList.remove('form-error');
            }
        });

        validateFormState(isValid, stepIndex);

        return isValid;
    };

    const validateFormState = (isValid, stepIndex) => {
        const submitFormLabel = document.getElementsByClassName('error-submit-button');

        if (isValid) {
            formState.validSteps[stepIndex] = true;
        } else {
            formState.validSteps[stepIndex] = false;
        }

        // validate form after each step
        let formValid = false;

        for (const [key, value] of Object.entries(formState.validSteps)) {
            formValid = value;
        }

        // toggle submit button if form is valid
        submitFormLabel[0].style.display = formValid ? 'none' : 'block';
        submitButton.disabled = !formValid;
    };


    const showStep = (stepIndex) => {
        if (stepIndex < 0 || stepIndex >= formSteps.length) {
            return;
        }

        formSteps[stepIndex].style.display = 'block';
        formSteps[stepIndex].classList.add('active');
        progressBar[stepIndex].classList.add('active');
        addEventListeners(stepIndex);
    };


    const initializeComplaintForm = () => {
        // This is called after DOM is loaded

        // Do not initialize if form is not rendered
        if (!form) {
            return;
        }

        submitButton.disabled = true;
        productFamilySelect.addEventListener('change', changeProductFamily);
        productSelect.addEventListener('change', changeProduct);
        
        noTime.addEventListener('change', function () {
            bestBeforeTime.disabled = this.checked;
            bestBeforeTime.required = this.checked ? false : true;

            const valid = validateStep(1);
            if (valid) {
                showStep(2);
            }
        });
        
        noDate.addEventListener('change', function () {
            bestBeforeDate.disabled = this.checked;
            bestBeforeDate.required = this.checked ? false : true;
            bestBeforeTime.required = this.checked ? false : true;
            timeFormRow.style.display = this.checked ? 'none' : 'grid';
            noDateHint.style.display = this.checked ? 'none' : 'block';

            const valid = validateStep(1);
            if (valid) {
                showStep(2);
            }
        });

        noLotNumber.addEventListener('change', function () {
            lotNumberField.disabled = this.checked;
            lotNumberField.required = this.checked ? false : true;
            const valid = validateStep(0);
            if (valid) {
                showStep(1);
            }
        });

        // initialize product dropdown
        changeProduct();
        
        // show initial step
        showStep(0);

        // check if form was previously submitted
        Array.from(formSteps).forEach((step, index) => {
            if (validateStep(index)) {
                showStep(index);
            } else {
                return;
            }  
        });
        
        form.style.display = 'block';
    };

    const parseQueryParams = () => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const questionType = urlParams.get('question-type');

        if (questionType) {
            const questionTypeRadio = document.getElementById(questionType);
            questionTypeRadio.checked = true;
            handleFormChoice({target: questionTypeRadio});
        }
    };

    const updateQueryParams = (questionType) => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        urlParams.set('question-type', questionType);
        window.history.replaceState({}, '', `${location.pathname}?${urlParams}`);
    };

    const handleFormChoice = (event) => {
        const questionType = event.target.value;

        contactForm.style.display = 'none';
        form.style.display = 'none';
        productQuestionForm.style.display = 'none';
        ingredientQuestionForm.style.display = 'none';

        if (questionType === 'complaint') {
            initializeComplaintForm();
            initializeProductFamilyDropdown();
        } else if (questionType === 'question-ingredients') {
            ingredientQuestionForm.style.display = 'block';
        } else if (questionType === 'question-buy') {
            productQuestionForm.style.display = 'block';
        } else {
            contactForm.style.display = 'block';
        }

        updateQueryParams(questionType);
    };

    var radios = document.querySelectorAll('input[type=radio][name="question-type"]');
    Array.prototype.forEach.call(radios, function(radio) {
        radio.addEventListener('change', handleFormChoice);
    });

    parseQueryParams();
    
});